unit View.Sincronizacao_Servidor_Retaguarda.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls,
  UHelperServer, UUtils, UWeb.Enum;

type
  TFViewSincronizacao_Servidor_RetaguardaEdit = class(TForm)
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbtabela_retaguarda: TLabel;
    edtabela_retaguarda: TDBEdit;
    lbcampos_consulta: TLabel;
    edcampos_consulta: TDBEdit;
    lbtabela_servidor: TLabel;
    edtabela_servidor: TDBEdit;
    lbexcluido: TLabel;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientSincronizacao_Servidor_RetaguardaGet: TXDataWebClient;
    Sincronizacao_Servidor_RetaguardaDataset: TXDataWebDataSet;
    Sincronizacao_Servidor_RetaguardaDatasetid: TIntegerField;
    Sincronizacao_Servidor_RetaguardaDatasettabela_retaguarda: TStringField;
    Sincronizacao_Servidor_RetaguardaDatasetcampos_consulta: TStringField;
    Sincronizacao_Servidor_RetaguardaDatasettabela_servidor: TStringField;
    Sincronizacao_Servidor_RetaguardaDatasetexcluido: TBooleanField;
    Sincronizacao_Servidor_RetaguardaDatasetinclusao: TDateTimeField;
    Sincronizacao_Servidor_RetaguardaDatasetalteracao: TDateTimeField;
    Sincronizacao_Servidor_RetaguardaDatasetexclusao: TDateTimeField;
    cbexcluido: TDBCheckBox;
    procedure btCancelClick(Sender: TObject);
    [async]
    procedure btSaveClick(Sender: TObject); async;
    procedure XDataClientSincronizacao_Servidor_RetaguardaGetLoad(Response: TXDataClientResponse);
    procedure Sincronizacao_Servidor_RetaguardaDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure Sincronizacao_Servidor_RetaguardaDatasetcampos_consultaGetText(
      Sender: TField; var Text: string; DisplayText: Boolean);
    procedure edtabela_retaguardaClick(Sender: TObject);
    procedure edtabela_servidorClick(Sender: TObject);
    procedure edcampos_consultaClick(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
    function ValidarDados : TArray<string>;
    procedure DesabilitarComponentes;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewSincronizacao_Servidor_RetaguardaEdit: TFViewSincronizacao_Servidor_RetaguardaEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewSincronizacao_Servidor_RetaguardaEdit }

procedure TFViewSincronizacao_Servidor_RetaguardaEdit.btSaveClick(Sender: TObject);
var
  lMensagem : string;
  lErro : TArray<string>;
begin
  lErro := ValidarDados;

  if lErro[0] <> '' then
  begin
    TUtils.SetErroClass(lErro[1], lErro[0]);

    Exit;
  end;

  lMensagem := 'Tem certeza que deseja cadastrar essa sincronização?';

  if not FInserting then
    lMensagem := 'Tem certeza que deseja alterar essa sincronização?';

  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, lMensagem)) then
  begin
    TUtils.ChamarDivLoading;

    if Sincronizacao_Servidor_RetaguardaDataset.State in dsEditModes then
    begin
      Sincronizacao_Servidor_RetaguardaDataset.FieldByName('campos_consulta').AsString :=
        THelperServer.FormatarJSON(edcampos_consulta.Text, False);
      Sincronizacao_Servidor_RetaguardaDataset.Post;
      Sincronizacao_Servidor_RetaguardaDataset.ApplyUpdates;
    end
    else
      FShowListProc;
  end;
end;

class function TFViewSincronizacao_Servidor_RetaguardaEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewSincronizacao_Servidor_RetaguardaEdit.DesabilitarComponentes;
begin
  btSave.Enabled := False;
  edtabela_retaguarda.Enabled := False;
  edtabela_servidor.Enabled := False;
  edcampos_consulta.Enabled := False;
  cbexcluido.Enabled := False;
end;

procedure TFViewSincronizacao_Servidor_RetaguardaEdit.edcampos_consultaClick(
  Sender: TObject);
begin
  TUtils.RemoverErroClass('view_sincronizacao_servidor_retaguarda_form_lbcampos_consulta');
end;

procedure TFViewSincronizacao_Servidor_RetaguardaEdit.edtabela_retaguardaClick(
  Sender: TObject);
begin
  TUtils.RemoverErroClass('view_sincronizacao_servidor_retaguarda_form_lbtabela_retaguarda');
end;

procedure TFViewSincronizacao_Servidor_RetaguardaEdit.edtabela_servidorClick(
  Sender: TObject);
begin
  TUtils.RemoverErroClass('view_sincronizacao_servidor_retaguarda_form_lbtabela_servidor');
end;

procedure TFViewSincronizacao_Servidor_RetaguardaEdit.InsertEntity;
begin
  Sincronizacao_Servidor_RetaguardaDataset.Close;
  Sincronizacao_Servidor_RetaguardaDataset.SetJsonData('{}');
  Sincronizacao_Servidor_RetaguardaDataset.Open;
  Sincronizacao_Servidor_RetaguardaDataset.Insert;
end;

class function TFViewSincronizacao_Servidor_RetaguardaEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewSincronizacao_Servidor_RetaguardaEdit(AForm).FInserting := AInserting;
    TFViewSincronizacao_Servidor_RetaguardaEdit(AForm).FId := AId;
    TFViewSincronizacao_Servidor_RetaguardaEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewSincronizacao_Servidor_RetaguardaEdit(AForm).InsertEntity
    else
      TFViewSincronizacao_Servidor_RetaguardaEdit(AForm).LoadEntity;
  end;

begin
  Application.CreateForm(TFViewSincronizacao_Servidor_RetaguardaEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewSincronizacao_Servidor_RetaguardaEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Sincronizacao_Servidor_RetaguardaDataset.Connection.Model.DefaultSchema.FindEntityType(
      Sincronizacao_Servidor_RetaguardaDataset.EntitySetName
    )
  );
  XDataClientSincronizacao_Servidor_RetaguardaGet.Get(Sincronizacao_Servidor_RetaguardaDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewSincronizacao_Servidor_RetaguardaEdit.XDataClientSincronizacao_Servidor_RetaguardaGetLoad(Response: TXDataClientResponse);
begin
  Sincronizacao_Servidor_RetaguardaDataset.Close;
  Sincronizacao_Servidor_RetaguardaDataset.SetJsonData(Response.Result);
  Sincronizacao_Servidor_RetaguardaDataset.Open;
  
  Sincronizacao_Servidor_RetaguardaDataset.Edit;  
end;

procedure TFViewSincronizacao_Servidor_RetaguardaEdit.Sincronizacao_Servidor_RetaguardaDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, ResolveInfo.Error);

      Sincronizacao_Servidor_RetaguardaDataset.Edit;

      Exit;
    end;
  end;

  TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Operação realizada com sucesso!');
  FShowListProc;
end;

procedure TFViewSincronizacao_Servidor_RetaguardaEdit.Sincronizacao_Servidor_RetaguardaDatasetcampos_consultaGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  if not FInserting then
    Text := THelperServer.FormatarJSON(Sender.AsString, True);
end;

function TFViewSincronizacao_Servidor_RetaguardaEdit.ValidarDados: TArray<string>;
begin
  TUtils.LimparErrosClass;

  SetLength(Result, 2);
  Result[0] := '';
  Result[1] := '';

  if THelperServer.VerificarCampoVazio(edtabela_servidor) then
  begin
    Result[0] := 'Insira o nome da tabela no servidor!';
    Result[1] := 'view_sincronizacao_servidor_retaguarda_form_lbtabela_servidor';
  end
  else if THelperServer.VerificarCampoVazio(edtabela_retaguarda) then
  begin
    Result[0] := 'Insira o nome da tabela no retaguarda!';
    Result[1] := 'view_sincronizacao_servidor_retaguarda_form_lbtabela_retaguarda';
  end
  else if THelperServer.VerificarCampoVazio(edcampos_consulta) then
  begin
    Result[0] := 'Insira o json com os campos da consulta!';
    Result[1] := 'view_sincronizacao_servidor_retaguarda_form_lbcampos_consulta';
  end
  else if not THelperServer.VerificarJsonArrayValido(edcampos_consulta.Text) then
  begin
    Result[0] := 'Json inserido é inválido!';
    Result[1] := 'view_sincronizacao_servidor_retaguarda_form_lbcampos_consulta';
  end;
end;

procedure TFViewSincronizacao_Servidor_RetaguardaEdit.WebFormShow(
  Sender: TObject);
begin
  if FInserting then
  begin
    THelperServer.RemoverDiv('campos-controle');

    if not TUtils.PossuiPermissao(Sincronizacao_Servidor_RetaguardaDataset.EntitySetName.ToLower, TTipoPermissao.INSERIR) then
      DesabilitarComponentes;
  end
  else
  begin
    if not TUtils.PossuiPermissao(Sincronizacao_Servidor_RetaguardaDataset.EntitySetName.ToLower, TTipoPermissao.ALTERAR) then
      DesabilitarComponentes;
  end;
end;

procedure TFViewSincronizacao_Servidor_RetaguardaEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewSincronizacao_Servidor_RetaguardaEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbid := TLabel.Create('view.sincronizacao_servidor_retaguarda.form.lbid');
  lbtabela_retaguarda := TLabel.Create('view.sincronizacao_servidor_retaguarda.form.lbtabela_retaguarda');
  lbcampos_consulta := TLabel.Create('view.sincronizacao_servidor_retaguarda.form.lbcampos_consulta');
  lbtabela_servidor := TLabel.Create('view.sincronizacao_servidor_retaguarda.form.lbtabela_servidor');
  lbexcluido := TLabel.Create('view.sincronizacao_servidor_retaguarda.form.lbexcluido');
  lbinclusao := TLabel.Create('view.sincronizacao_servidor_retaguarda.form.lbinclusao');
  lbalteracao := TLabel.Create('view.sincronizacao_servidor_retaguarda.form.lbalteracao');
  lbexclusao := TLabel.Create('view.sincronizacao_servidor_retaguarda.form.lbexclusao');
  btCancel := TButton.Create('view.sincronizacao_servidor_retaguarda.form.btBack');
  btSave := TButton.Create('view.sincronizacao_servidor_retaguarda.form.btSave');
  edid := TDBEdit.Create('view.sincronizacao_servidor_retaguarda.form.edid');
  edtabela_retaguarda := TDBEdit.Create('view.sincronizacao_servidor_retaguarda.form.edtabela_retaguarda');
  edcampos_consulta := TDBEdit.Create('view.sincronizacao_servidor_retaguarda.form.edcampos_consulta');
  edtabela_servidor := TDBEdit.Create('view.sincronizacao_servidor_retaguarda.form.edtabela_servidor');
  edinclusao := TDBEdit.Create('view.sincronizacao_servidor_retaguarda.form.edinclusao');
  edalteracao := TDBEdit.Create('view.sincronizacao_servidor_retaguarda.form.edalteracao');
  edexclusao := TDBEdit.Create('view.sincronizacao_servidor_retaguarda.form.edexclusao');
  cbexcluido := TDBCheckBox.Create('view.sincronizacao_servidor_retaguarda.form.cbexcluido');
  DataSource := TDataSource.Create(Self);
  Sincronizacao_Servidor_RetaguardaDataset := TXDataWebDataSet.Create(Self);
  Sincronizacao_Servidor_RetaguardaDatasetid := TIntegerField.Create(Self);
  Sincronizacao_Servidor_RetaguardaDatasettabela_retaguarda := TStringField.Create(Self);
  Sincronizacao_Servidor_RetaguardaDatasetcampos_consulta := TStringField.Create(Self);
  Sincronizacao_Servidor_RetaguardaDatasettabela_servidor := TStringField.Create(Self);
  Sincronizacao_Servidor_RetaguardaDatasetexcluido := TBooleanField.Create(Self);
  Sincronizacao_Servidor_RetaguardaDatasetinclusao := TDateTimeField.Create(Self);
  Sincronizacao_Servidor_RetaguardaDatasetalteracao := TDateTimeField.Create(Self);
  Sincronizacao_Servidor_RetaguardaDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientSincronizacao_Servidor_RetaguardaGet := TXDataWebClient.Create(Self);

  lbid.BeforeLoadDFMValues;
  lbtabela_retaguarda.BeforeLoadDFMValues;
  lbcampos_consulta.BeforeLoadDFMValues;
  lbtabela_servidor.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  edtabela_retaguarda.BeforeLoadDFMValues;
  edcampos_consulta.BeforeLoadDFMValues;
  edtabela_servidor.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  cbexcluido.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Sincronizacao_Servidor_RetaguardaDataset.BeforeLoadDFMValues;
  Sincronizacao_Servidor_RetaguardaDatasetid.BeforeLoadDFMValues;
  Sincronizacao_Servidor_RetaguardaDatasettabela_retaguarda.BeforeLoadDFMValues;
  Sincronizacao_Servidor_RetaguardaDatasetcampos_consulta.BeforeLoadDFMValues;
  Sincronizacao_Servidor_RetaguardaDatasettabela_servidor.BeforeLoadDFMValues;
  Sincronizacao_Servidor_RetaguardaDatasetexcluido.BeforeLoadDFMValues;
  Sincronizacao_Servidor_RetaguardaDatasetinclusao.BeforeLoadDFMValues;
  Sincronizacao_Servidor_RetaguardaDatasetalteracao.BeforeLoadDFMValues;
  Sincronizacao_Servidor_RetaguardaDatasetexclusao.BeforeLoadDFMValues;
  XDataClientSincronizacao_Servidor_RetaguardaGet.BeforeLoadDFMValues;
  try
    Name := 'FViewSincronizacao_Servidor_RetaguardaEdit';
    Width := 470;
    Height := 238;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 8;
    lbid.Top := 8;
    lbid.Width := 27;
    lbid.Height := 13;
    lbid.Caption := 'C'#243'd.:';
    lbid.HeightPercent := 100.000000000000000000;
    lbid.WidthPercent := 100.000000000000000000;
    lbtabela_retaguarda.SetParentComponent(Self);
    lbtabela_retaguarda.Name := 'lbtabela_retaguarda';
    lbtabela_retaguarda.Left := 8;
    lbtabela_retaguarda.Top := 35;
    lbtabela_retaguarda.Width := 96;
    lbtabela_retaguarda.Height := 13;
    lbtabela_retaguarda.Caption := 'Tabela Retaguarda:';
    lbtabela_retaguarda.HeightPercent := 100.000000000000000000;
    lbtabela_retaguarda.WidthPercent := 100.000000000000000000;
    lbcampos_consulta.SetParentComponent(Self);
    lbcampos_consulta.Name := 'lbcampos_consulta';
    lbcampos_consulta.Left := 8;
    lbcampos_consulta.Top := 62;
    lbcampos_consulta.Width := 87;
    lbcampos_consulta.Height := 13;
    lbcampos_consulta.Caption := 'Campos Consulta:';
    lbcampos_consulta.HeightPercent := 100.000000000000000000;
    lbcampos_consulta.WidthPercent := 100.000000000000000000;
    lbtabela_servidor.SetParentComponent(Self);
    lbtabela_servidor.Name := 'lbtabela_servidor';
    lbtabela_servidor.Left := 8;
    lbtabela_servidor.Top := 89;
    lbtabela_servidor.Width := 79;
    lbtabela_servidor.Height := 13;
    lbtabela_servidor.Caption := 'Tabela Servidor:';
    lbtabela_servidor.HeightPercent := 100.000000000000000000;
    lbtabela_servidor.WidthPercent := 100.000000000000000000;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 8;
    lbexcluido.Top := 116;
    lbexcluido.Width := 44;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'Exclu'#237'do?';
    lbexcluido.HeightPercent := 100.000000000000000000;
    lbexcluido.WidthPercent := 100.000000000000000000;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 248;
    lbinclusao.Top := 8;
    lbinclusao.Width := 44;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'Inclus'#227'o:';
    lbinclusao.HeightPercent := 100.000000000000000000;
    lbinclusao.WidthPercent := 100.000000000000000000;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 248;
    lbalteracao.Top := 35;
    lbalteracao.Width := 50;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'Altera'#231#227'o:';
    lbalteracao.HeightPercent := 100.000000000000000000;
    lbalteracao.WidthPercent := 100.000000000000000000;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 248;
    lbexclusao.Top := 62;
    lbexclusao.Width := 46;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'Exclus'#227'o:';
    lbexclusao.HeightPercent := 100.000000000000000000;
    lbexclusao.WidthPercent := 100.000000000000000000;
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 110;
    btCancel.Top := 157;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Voltar';
    btCancel.HeightPercent := 100.000000000000000000;
    btCancel.TabOrder := 1;
    btCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 8;
    btSave.Top := 157;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Salvar';
    btSave.HeightPercent := 100.000000000000000000;
    btSave.TabOrder := 4;
    btSave.WidthPercent := 100.000000000000000000;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 125;
    edid.Top := 5;
    edid.Width := 100;
    edid.Height := 21;
    edid.Enabled := False;
    edid.HeightPercent := 100.000000000000000000;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.WidthPercent := 100.000000000000000000;
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    edtabela_retaguarda.SetParentComponent(Self);
    edtabela_retaguarda.Name := 'edtabela_retaguarda';
    edtabela_retaguarda.Left := 125;
    edtabela_retaguarda.Top := 32;
    edtabela_retaguarda.Width := 100;
    edtabela_retaguarda.Height := 21;
    edtabela_retaguarda.CharCase := wecUpperCase;
    edtabela_retaguarda.HeightPercent := 100.000000000000000000;
    edtabela_retaguarda.TabOrder := 7;
    edtabela_retaguarda.Text := 'edtabela_retaguarda';
    edtabela_retaguarda.WidthPercent := 100.000000000000000000;
    SetEvent(edtabela_retaguarda, Self, 'OnClick', 'edtabela_retaguardaClick');
    edtabela_retaguarda.DataField := 'tabela_retaguarda';
    edtabela_retaguarda.DataSource := DataSource;
    edcampos_consulta.SetParentComponent(Self);
    edcampos_consulta.Name := 'edcampos_consulta';
    edcampos_consulta.Left := 125;
    edcampos_consulta.Top := 59;
    edcampos_consulta.Width := 100;
    edcampos_consulta.Height := 21;
    edcampos_consulta.HeightPercent := 100.000000000000000000;
    edcampos_consulta.TabOrder := 8;
    edcampos_consulta.Text := 'edcampos_consulta';
    edcampos_consulta.WidthPercent := 100.000000000000000000;
    SetEvent(edcampos_consulta, Self, 'OnClick', 'edcampos_consultaClick');
    edcampos_consulta.DataField := 'campos_consulta';
    edcampos_consulta.DataSource := DataSource;
    edtabela_servidor.SetParentComponent(Self);
    edtabela_servidor.Name := 'edtabela_servidor';
    edtabela_servidor.Left := 125;
    edtabela_servidor.Top := 86;
    edtabela_servidor.Width := 100;
    edtabela_servidor.Height := 21;
    edtabela_servidor.CharCase := wecLowerCase;
    edtabela_servidor.HeightPercent := 100.000000000000000000;
    edtabela_servidor.TabOrder := 9;
    edtabela_servidor.Text := 'edtabela_servidor';
    edtabela_servidor.WidthPercent := 100.000000000000000000;
    SetEvent(edtabela_servidor, Self, 'OnClick', 'edtabela_servidorClick');
    edtabela_servidor.DataField := 'tabela_servidor';
    edtabela_servidor.DataSource := DataSource;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 317;
    edinclusao.Top := 5;
    edinclusao.Width := 100;
    edinclusao.Height := 21;
    edinclusao.Enabled := False;
    edinclusao.HeightPercent := 100.000000000000000000;
    edinclusao.TabOrder := 11;
    edinclusao.Text := 'edinclusao';
    edinclusao.WidthPercent := 100.000000000000000000;
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 317;
    edalteracao.Top := 32;
    edalteracao.Width := 100;
    edalteracao.Height := 21;
    edalteracao.Enabled := False;
    edalteracao.HeightPercent := 100.000000000000000000;
    edalteracao.TabOrder := 12;
    edalteracao.Text := 'edalteracao';
    edalteracao.WidthPercent := 100.000000000000000000;
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 317;
    edexclusao.Top := 59;
    edexclusao.Width := 100;
    edexclusao.Height := 21;
    edexclusao.Enabled := False;
    edexclusao.HeightPercent := 100.000000000000000000;
    edexclusao.TabOrder := 13;
    edexclusao.Text := 'edexclusao';
    edexclusao.WidthPercent := 100.000000000000000000;
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    cbexcluido.SetParentComponent(Self);
    cbexcluido.Name := 'cbexcluido';
    cbexcluido.Left := 125;
    cbexcluido.Top := 113;
    cbexcluido.Width := 100;
    cbexcluido.Height := 22;
    cbexcluido.Caption := 'cbexcluido';
    cbexcluido.ChildOrder := 13;
    cbexcluido.HeightPercent := 100.000000000000000000;
    cbexcluido.WidthPercent := 100.000000000000000000;
    cbexcluido.DataField := 'excluido';
    cbexcluido.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Sincronizacao_Servidor_RetaguardaDataset;
    DataSource.Left := 392;
    DataSource.Top := 96;
    Sincronizacao_Servidor_RetaguardaDataset.SetParentComponent(Self);
    Sincronizacao_Servidor_RetaguardaDataset.Name := 'Sincronizacao_Servidor_RetaguardaDataset';
    Sincronizacao_Servidor_RetaguardaDataset.AfterApplyUpdates := Sincronizacao_Servidor_RetaguardaDatasetAfterApplyUpdates;
    Sincronizacao_Servidor_RetaguardaDataset.EntitySetName := 'Sincronizacao_Servidor_Retaguarda';
    Sincronizacao_Servidor_RetaguardaDataset.Connection := DMConnection.ApiConnection;
    Sincronizacao_Servidor_RetaguardaDataset.Left := 336;
    Sincronizacao_Servidor_RetaguardaDataset.Top := 96;
    Sincronizacao_Servidor_RetaguardaDatasetid.SetParentComponent(Sincronizacao_Servidor_RetaguardaDataset);
    Sincronizacao_Servidor_RetaguardaDatasetid.Name := 'Sincronizacao_Servidor_RetaguardaDatasetid';
    Sincronizacao_Servidor_RetaguardaDatasetid.FieldName := 'id';
    Sincronizacao_Servidor_RetaguardaDatasettabela_retaguarda.SetParentComponent(Sincronizacao_Servidor_RetaguardaDataset);
    Sincronizacao_Servidor_RetaguardaDatasettabela_retaguarda.Name := 'Sincronizacao_Servidor_RetaguardaDatasettabela_retaguarda';
    Sincronizacao_Servidor_RetaguardaDatasettabela_retaguarda.FieldName := 'tabela_retaguarda';
    Sincronizacao_Servidor_RetaguardaDatasettabela_retaguarda.Required := True;
    Sincronizacao_Servidor_RetaguardaDatasettabela_retaguarda.Size := 255;
    Sincronizacao_Servidor_RetaguardaDatasetcampos_consulta.SetParentComponent(Sincronizacao_Servidor_RetaguardaDataset);
    Sincronizacao_Servidor_RetaguardaDatasetcampos_consulta.Name := 'Sincronizacao_Servidor_RetaguardaDatasetcampos_consulta';
    Sincronizacao_Servidor_RetaguardaDatasetcampos_consulta.FieldName := 'campos_consulta';
    Sincronizacao_Servidor_RetaguardaDatasetcampos_consulta.Required := True;
    SetEvent(Sincronizacao_Servidor_RetaguardaDatasetcampos_consulta, Self, 'OnGetText', 'Sincronizacao_Servidor_RetaguardaDatasetcampos_consultaGetText');
    Sincronizacao_Servidor_RetaguardaDatasetcampos_consulta.Size := 255;
    Sincronizacao_Servidor_RetaguardaDatasettabela_servidor.SetParentComponent(Sincronizacao_Servidor_RetaguardaDataset);
    Sincronizacao_Servidor_RetaguardaDatasettabela_servidor.Name := 'Sincronizacao_Servidor_RetaguardaDatasettabela_servidor';
    Sincronizacao_Servidor_RetaguardaDatasettabela_servidor.FieldName := 'tabela_servidor';
    Sincronizacao_Servidor_RetaguardaDatasettabela_servidor.Required := True;
    Sincronizacao_Servidor_RetaguardaDatasettabela_servidor.Size := 255;
    Sincronizacao_Servidor_RetaguardaDatasetexcluido.SetParentComponent(Sincronizacao_Servidor_RetaguardaDataset);
    Sincronizacao_Servidor_RetaguardaDatasetexcluido.Name := 'Sincronizacao_Servidor_RetaguardaDatasetexcluido';
    Sincronizacao_Servidor_RetaguardaDatasetexcluido.FieldName := 'excluido';
    Sincronizacao_Servidor_RetaguardaDatasetinclusao.SetParentComponent(Sincronizacao_Servidor_RetaguardaDataset);
    Sincronizacao_Servidor_RetaguardaDatasetinclusao.Name := 'Sincronizacao_Servidor_RetaguardaDatasetinclusao';
    Sincronizacao_Servidor_RetaguardaDatasetinclusao.FieldName := 'inclusao';
    Sincronizacao_Servidor_RetaguardaDatasetinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    Sincronizacao_Servidor_RetaguardaDatasetalteracao.SetParentComponent(Sincronizacao_Servidor_RetaguardaDataset);
    Sincronizacao_Servidor_RetaguardaDatasetalteracao.Name := 'Sincronizacao_Servidor_RetaguardaDatasetalteracao';
    Sincronizacao_Servidor_RetaguardaDatasetalteracao.FieldName := 'alteracao';
    Sincronizacao_Servidor_RetaguardaDatasetalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    Sincronizacao_Servidor_RetaguardaDatasetexclusao.SetParentComponent(Sincronizacao_Servidor_RetaguardaDataset);
    Sincronizacao_Servidor_RetaguardaDatasetexclusao.Name := 'Sincronizacao_Servidor_RetaguardaDatasetexclusao';
    Sincronizacao_Servidor_RetaguardaDatasetexclusao.FieldName := 'exclusao';
    Sincronizacao_Servidor_RetaguardaDatasetexclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    XDataClientSincronizacao_Servidor_RetaguardaGet.SetParentComponent(Self);
    XDataClientSincronizacao_Servidor_RetaguardaGet.Name := 'XDataClientSincronizacao_Servidor_RetaguardaGet';
    XDataClientSincronizacao_Servidor_RetaguardaGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientSincronizacao_Servidor_RetaguardaGet, Self, 'OnLoad', 'XDataClientSincronizacao_Servidor_RetaguardaGetLoad');
    XDataClientSincronizacao_Servidor_RetaguardaGet.Left := 280;
    XDataClientSincronizacao_Servidor_RetaguardaGet.Top := 96;
  finally
    lbid.AfterLoadDFMValues;
    lbtabela_retaguarda.AfterLoadDFMValues;
    lbcampos_consulta.AfterLoadDFMValues;
    lbtabela_servidor.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    edtabela_retaguarda.AfterLoadDFMValues;
    edcampos_consulta.AfterLoadDFMValues;
    edtabela_servidor.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    cbexcluido.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Sincronizacao_Servidor_RetaguardaDataset.AfterLoadDFMValues;
    Sincronizacao_Servidor_RetaguardaDatasetid.AfterLoadDFMValues;
    Sincronizacao_Servidor_RetaguardaDatasettabela_retaguarda.AfterLoadDFMValues;
    Sincronizacao_Servidor_RetaguardaDatasetcampos_consulta.AfterLoadDFMValues;
    Sincronizacao_Servidor_RetaguardaDatasettabela_servidor.AfterLoadDFMValues;
    Sincronizacao_Servidor_RetaguardaDatasetexcluido.AfterLoadDFMValues;
    Sincronizacao_Servidor_RetaguardaDatasetinclusao.AfterLoadDFMValues;
    Sincronizacao_Servidor_RetaguardaDatasetalteracao.AfterLoadDFMValues;
    Sincronizacao_Servidor_RetaguardaDatasetexclusao.AfterLoadDFMValues;
    XDataClientSincronizacao_Servidor_RetaguardaGet.AfterLoadDFMValues;
  end;
end;

end.
